"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var orderDetailSaveButton = document.getElementById('orderDetailSaveButton');
    if (orderDetailSaveButton && !window.orderDetailSaveRegistered) {
        orderDetailSaveButton.addEventListener('click', saveOrderAdmin);
        window.orderDetailSaveRegistered = true;
    }

    function saveOrderAdmin() {

        var stateComboBoxes = document.querySelectorAll('select.order-item-state-combo');
        var requestBody = { Items: [] };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = stateComboBoxes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var combo = _step.value;

                var savedObject = { Id: combo.dataset.orderItemId, State: combo.value };
                requestBody.Items.push(savedObject);

                var row = combo.closest('tr');
                if (!row) continue;

                var orderedAmountInput = row.querySelector('.editable-integer');
                if (!orderedAmountInput || /^[0-9]{1,5}$/.test(orderedAmountInput.value)) {
                    savedObject.OrderedAmount = parseInt(orderedAmountInput.value);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var ajaxHelper = new _ajaxHelper2.default();
        ajaxHelper.sendRequest('/Orders/SaveOrderItemsStates', saveOrderAdminDone, JSON.stringify(requestBody));
    }

    function saveOrderAdminDone(request, responseObject) {

        if (responseObject.success) {
            var message = responseObject.result.message;

            (0, _sweetalert2.default)({ text: message, title: message }, function () {
                window.location.reload();
            });
        } else {
            _notify2.default.error(responseObject.message);
            console.error(responseObject.detail);
        }
    }
};

var _ajaxHelper = require("../ajaxHelper");

var _ajaxHelper2 = _interopRequireDefault(_ajaxHelper);

var _notify = require("linksoft/notify");

var _notify2 = _interopRequireDefault(_notify);

var _sweetalert = require("sweetalert");

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/Initializers/orders.js
// module id = 407
// module chunks = 0